import axios from "./axios"
import rawAxios from "axios"

export default {
  getFieldsConfig: async (businessType, category) => {
    try {
      const result = await axios.get("/user_applications/fields_config", {
        params: {
          business_type: businessType,
          category: category
        }
      })
      return result
    } catch (error) {
      throw error
    }
  },
  signUpApply: async (params, files = {}) => {
    try {
      const formData = new FormData()
      
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined) {
          if (typeof params[key] === 'object' && !(params[key] instanceof File)) {
            formData.append(key, JSON.stringify(params[key]))
          } else {
            formData.append(key, params[key])
          }
        }
      })
      
      // Support single file or arrays; always send as documents[]
      const appendDocuments = (maybeFiles) => {
        if (!maybeFiles) return
        const list = Array.isArray(maybeFiles) ? maybeFiles : [maybeFiles]
        list.forEach((file) => {
          if (file) formData.append("documents[]", file)
        })
      }

      // Support single file or arrays for a named field
      const appendNamedDocuments = (fieldName, maybeFiles) => {
        if (!maybeFiles) return
        const list = Array.isArray(maybeFiles) ? maybeFiles : [maybeFiles]
        list.forEach((file) => {
          if (file) formData.append(fieldName, file)
        })
      }

      appendDocuments(files.goodsServicesFiles || files.goodsServicesFile)
      appendDocuments(files.certificationsFiles || files.certificationsFile)
      appendDocuments(files.programsServicesFiles || files.programsServicesFile)
      appendNamedDocuments(
        "quality_certification_documents[]",
        files.qualityCertificationsFiles || files.qualityCertificationsFile,
      )
      
      const result = await axios.post("/user_applications", formData)
      return result
    } catch (error) {
      throw error
    }
  },
  getUserApplication: async (id) => {
    try {
      // Use raw axios with the same base URL but no interceptors
      const result = await rawAxios.get(`${axios.defaults.baseURL}/user_applications/${id}`)
      return result
    } catch (error) {
      throw error
    }
  },
  getUserApplicationByCode: async (code) => {
    try {
      // Backend supports code-based lookup - it checks if ID looks like hex code
      // Use raw axios with the same base URL but no interceptors
      const result = await rawAxios.get(`${axios.defaults.baseURL}/user_applications/${code}`)
      return result
    } catch (error) {
      throw error
    }
  },
  getUserApplications: async (page = 1, perPage = 20, filters = {}) => {
    try {
      const params = {
        page,
        per_page: perPage,
        ...filters
      }
      const result = await axios.get("/user_applications", { params })
      return result
    } catch (error) {
      throw error
    }
  },
  acceptApplication: async (id, subscriptionPlan) => {
    try {
      // Only include subscription_plan in the payload if it's provided
      const payload = subscriptionPlan ? { subscription_plan: subscriptionPlan } : {}
      const result = await axios.post(`/user_applications/${id}/approve`, payload)
      return result
    } catch (error) {
      throw error
    }
  },
  rejectApplication: async (id, rejectionNotes = null) => {
    try {
      const payload = rejectionNotes ? { rejection_notes: rejectionNotes } : {}
      const result = await axios.post(`/user_applications/${id}/reject`, payload)
      return result
    } catch (error) {
      throw error
    }
  },
  requestDetails: async (id, requestMessage) => {
    try {
      const result = await axios.post(`/user_applications/${id}/request_details`, {
        request_message: requestMessage
      })
      return result
    } catch (error) {
      throw error
    }
  },
  updateApplication: async (id, params, files = {}) => {
    try {
      const formData = new FormData()
      
      Object.keys(params).forEach((key) => {
        if (params[key] !== null && params[key] !== undefined) {
          if (typeof params[key] === 'object' && !(params[key] instanceof File)) {
            formData.append(key, JSON.stringify(params[key]))
          } else {
            formData.append(key, params[key])
          }
        }
      })
      
      // Support single file or arrays; always send as documents[]
      const appendDocuments = (maybeFiles) => {
        if (!maybeFiles) return
        const list = Array.isArray(maybeFiles) ? maybeFiles : [maybeFiles]
        list.forEach((file) => {
          if (file) formData.append("documents[]", file)
        })
      }

      // Support single file or arrays for a named field
      const appendNamedDocuments = (fieldName, maybeFiles) => {
        if (!maybeFiles) return
        const list = Array.isArray(maybeFiles) ? maybeFiles : [maybeFiles]
        list.forEach((file) => {
          if (file) formData.append(fieldName, file)
        })
      }

      appendDocuments(files.goodsServicesFiles || files.goodsServicesFile)
      appendDocuments(files.certificationsFiles || files.certificationsFile)
      appendDocuments(files.programsServicesFiles || files.programsServicesFile)
      appendNamedDocuments(
        "quality_certification_documents[]",
        files.qualityCertificationsFiles || files.qualityCertificationsFile,
      )
      
      const result = await axios.put(`/user_applications/${id}`, formData)
      return result
    } catch (error) {
      throw error
    }
  },
  getApplicationCounts: async (filters = {}) => {
    try {
      const params = {
        ...filters
      }
      const result = await axios.get("/user_applications/counts", { params })
      return result
    } catch (error) {
      throw error
    }
  },
  transitionStatus: async (id, status, notes = null) => {
    try {
      const result = await axios.post(`/user_applications/${id}/transition_status`, {
        status,
        notes
      })
      return result
    } catch (error) {
      throw error
    }
  }
} 
